import {format, isValid, parseISO} from 'date-fns';
import {ko} from 'date-fns/locale';

/**@returns 25-09-11(목) 15:23:00 */
export function formatKoreanDateTime(date) {
    const d = date instanceof Date ? date : typeof date === 'string' ? parseISO(date) : new Date(date);

    const validDate = isValid(d) ? d : new Date();
    return format(validDate, 'yy-MM-dd(EEE) HH:mm:ss', { locale: ko });
}
